<section class="relative">
  <div mat-dialog-close class="dialog-container__close dialog-container__close--l dialog-container__close--white cursor-pointer absolute" aria-label="Close dialog">
    <mat-icon svgIcon="close-circle"></mat-icon>
  </div>

  <div class="flex flex-col">
    <div class="ml-4 my-4 pt-2">
      <span class="overline-o1">{{ 'inviteMember.title' | translate }}</span>
    </div>

    <div><hr class="divider"></div>

    <div class="my-4">
      <form (ngSubmit)="send()">
        <div class="mx-4 flex flex-col gap-2">
          <app-input [type]="'text'" [control]="form.get('email')" [label]="'inviteMember.email' | translate"></app-input>
          <app-input [type]="'text'" [control]="form.get('name')" [label]="'inviteMember.name' | translate"></app-input>
          <app-select [type]="'locale'" [control]="form.get('locale')" [label]="'inviteMember.locale' | translate"></app-select>

          <div class="flex gap-4 mt-1">
            <mat-checkbox [formControl]="form.controls.isAdmin">
              {{ 'inviteMember.isAdmin' | translate }}
            </mat-checkbox>
            <mat-checkbox [formControl]="form.controls.isManager">
              {{ 'inviteMember.isManager' | translate }}
            </mat-checkbox>
          </div>

          <app-input [type]="'text'" [control]="form.get('welcomeMessage')" [label]="'inviteMember.welcomeMessage' | translate"></app-input>
        </div>

        <hr class="divider mt-4 mr-4">

        <div class="flex justify-end pt-2 mx-4">
          <app-button-secondary [type]="'submit'" [disabled]="sending">
            {{ 'inviteMember.send' | translate }}
          </app-button-secondary>
        </div>
      </form>
    </div>
  </div>
</section>
